import { TeamNanoID } from '../teams/teamsTypes';
import { CompanyGeneralLedgerID } from '../companies/companiesTypes';
import { AccountTypeNanoID } from '../accountTypes/accountTypesTypes';
import { AccountID, AccountNanoID } from '../accounts/accountsTypes';

export class AccountCache {
  static showCacheKey() {
    return 'account';
  }
  static companyPaymentsAccountsAssetsCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-payments-accounts-assets`;
  }
  static companyPaymentsAccountsEquityCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-payments-accounts-equity`;
  }
  static companyPaymentsAccountsLiabilityCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-payments-accounts-liability`;
  }
  static companyPaymentsAccountsProvisionsCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-payments-accounts-provisions`;
  }
  static companyBalanceAccountsCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-balance-accounts`;
  }
  static companyCashAccountCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-cash-accounts`;
  }
  static companyDebtAccountCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-debt-account`;
  }
  static companyRevenueAccountCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-revenue-account`;
  }
  static companiesPageAccountsCacheKey(companyNanoId: TeamNanoID[]) {
    return `companies-${companyNanoId.join('-')}-all-accounts`;
  }
  static companyAccountsSelectCacheKey(
    companyNanoId: TeamNanoID,
    accounts: string[] = []
  ) {
    return `company-${companyNanoId}-${accounts.join('-')}-accounts`;
  }
  static performerRevenueAccountCacheKey(companyNanoId: TeamNanoID) {
    return `performer-${companyNanoId}-revenue-account`;
  }
  static companyAccountsByAccountType(
    companyNanoId: TeamNanoID,
    accountTypeNanoId: AccountTypeNanoID
  ) {
    return `company-${companyNanoId}-accounts-by-account-type-${accountTypeNanoId}`;
  }
  static generalLedgerAccountsByAccountType(
    generalLedgerId: CompanyGeneralLedgerID,
    accountTypeNanoId: AccountTypeNanoID
  ) {
    return `general-ledger-${generalLedgerId}-accounts-by-account-type-${accountTypeNanoId}`;
  }
  static showRedirectCacheKey(accountId: AccountID) {
    return `account-${accountId}-redirect`;
  }

  static companyDashboardAccountsCacheKey(companyNanoId: TeamNanoID) {
    return `company-${companyNanoId}-dashboard-accounts`;
  }

  static accountBalances(accountNanoId: AccountNanoID) {
    return `account-${accountNanoId}-account-balances`;
  }

  static companyAccountBalances() {
    return `company-account-balances`;
  }

  static generalLedgerIncomeStatementAccountsCacheKey(
    generalLedgerId: CompanyGeneralLedgerID
  ) {
    return `general-ledger-${generalLedgerId}-income-statement-accounts`;
  }
}
